import React from 'react';

const About = () => {
  return (
    <div>
      <h1 class="mb-0 slackey-regular">About Us</h1>
      <p>We are a company dedicated to facilitating and enhancing foreign language learning and acquisition.</p>
      {/* Add more complex JSX here as your component grows */}
    </div>
  );
};

export default About;